import { z } from 'zod';
import { PartType } from '../../constants/part-type.js';
import { requiredEnumIdString, requiredUuidString } from '../zod-helpers/index.js';
import { PART_CONSTRAINTS } from './constraints.js';
// Not derived from partCreateFormFieldsSchema: every other createPart field is optional at the resolver.
export const partQuickCreateFormSchema = z.object({
    num: z
        .string()
        .trim()
        .min(1, `${PART_CONSTRAINTS.num.label} is required.`)
        .max(PART_CONSTRAINTS.num.maxLength),
    typeId: requiredEnumIdString(PartType, 'Part type is required.', 'Part type must be a valid selection.'),
    uomId: requiredUuidString('Stocking UOM is required.', 'Invalid stocking UOM selection.'),
    name: z.string().max(PART_CONSTRAINTS.name.maxLength).optional(),
    description: z.string().trim().max(PART_CONSTRAINTS.description.maxLength).optional(),
});
//# sourceMappingURL=quick-create-form.js.map